import { Phrases } from '@shared/models/locales.model';

export default {
  ChatLogs: 'سجل المحادثات',
  Search: 'بحث...',
  NoChatsYetDescription: 'ابدأ محادثة، وستظهر محادثاتك هنا.',
  NoChatHistory: 'لا يوجد سجل محادثات',
  NoChatHistoryDescription: 'ستظهر محادثاتك السابقة هنا',
  NoActiveChats: 'لا توجد محادثات نشطة',
  YouLabel: 'أنت:',
  FleetLabel: 'الأسطول:',
  DriverLabel: 'السائق:',
  CustomerLabel: 'العميل:',
  Today: 'اليوم',
  Yesterday: 'أمس',
  You: 'أنت (العميل)',
  OriginalBid: 'العرض الأصلي:',
  StartConversation: 'ابدأ محادثة',
  SendMessageTo: 'أرسل رسالة إلى {{name}}',
  NoMessagesToShow: 'لا توجد رسائل لعرضها',
  NoChatHistoryWith: 'لا يوجد سجل محادثات مع {{name}}',
  Price: 'السعر',
  Increase: 'زيادة السعر',
  Decrease: 'تقليل السعر',
  SendOffer: 'إرسال عرض',
  TypeMessage: 'اكتب رسالة...',
  Send: 'إرسال',
  CannotSendMessages: 'لا يمكنك إرسال رسائل في هذه المحادثة',
  TryAgainLater: 'حدث خطأ ما. يرجى المحاولة لاحقًا.',
  Retry: 'إعادة المحاولة',
  Back: 'رجوع',
  Close: 'إغلاق',
  CounterOfferSent: 'تم إرسال عرض مضاد',
  NewOfferReceived: 'عرض جديد',
  OfferAccepted: 'تم قبول العرض',
  OfferRejected: 'تم رفض العرض',
  OfferDeactivated: 'العرض لم يعد متاحًا',
  YouCounterOffered: 'عرضك المضاد',
  WaitingForAcceptance: 'في انتظار موافقة {{name}}',
  AcceptOffer: 'قبول العرض',
  AcceptFailed: 'تعذّر قبول هذا العرض، ربما لم يعد متاحًا.',
  Sending: 'جارٍ الإرسال',
  Sent: 'تم الإرسال',
  NotSent: 'لم تُرسل',
  OfferPreview: 'عرض:',
  UnreadMessages: '{{count}} رسائل غير مقروءة',
  OfferNotSent: 'لم يتم إرسال العرض',
  NewMessageFrom: 'رسالة جديدة من {{name}}',
  NewOfferFrom: 'عرض جديد من {{name}}',
  OfferToastBody: 'عرض: {{price}} ريال',
} as Phrases;
